export const generateOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "LovaBuild",
    "url": "https://lovabuild.com",
    "logo": "https://lovabuild.com/logo.png",
    "description": "AI-powered web apps & internal tools development under $5K in 10 days.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Your City",
      "addressRegion": "Your Region",
      "addressCountry": "Your Country"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+2348039260734",
      "contactType": "customer service",
      "email": "wole@iselectdigital.com"
    },
    "sameAs": [
      "https://twitter.com/wolexfeelcool",
      "https://www.linkedin.com/company/lovabuild",
      "https://github.com/lovabuild"
    ]
  };
};

export const generateServiceSchema = (service: {
  name: string;
  description: string;
  provider: string;
  url?: string;
  image?: string;
}) => {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": service.name,
    "description": service.description,
    "provider": {
      "@type": "Organization",
      "name": service.provider
    },
    "url": service.url || `https://lovabuild.com/services/${service.name.toLowerCase().replace(/\s+/g, '-')}`,
    "image": service.image || "https://lovabuild.com/images/services/default.jpg"
  };
};

export const generateFAQSchema = (faqs: Array<{ question: string; answer: string }>) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};

export const generateArticleSchema = (article: {
  headline: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  author: string;
}) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.headline,
    "description": article.description,
    "image": article.image,
    "datePublished": article.datePublished,
    "dateModified": article.dateModified,
    "author": {
      "@type": "Person",
      "name": article.author
    },
    "publisher": {
      "@type": "Organization",
      "name": "LovaBuild",
      "logo": {
        "@type": "ImageObject",
        "url": "https://lovabuild.com/logo.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://lovabuild.com/blog/" + article.headline.toLowerCase().replace(/\s+/g, '-')
    }
  };
};

export const generateBreadcrumbSchema = (breadcrumbs: Array<{ name: string; item: string }>) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((breadcrumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": breadcrumb.name,
      "item": breadcrumb.item
    }))
  };
};
